import React, { PureComponent } from "react";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

const data = [
  {
    name: "1",
    Count: 100
  },
  {
    name: "2",
    Count: 250
  },
  {
    name: "3",
    Count: 300
  },
  {
    name: "4",
    Count: 600
  },
  {
    name: "5",
    Count: 1000
  },
  {
    name: "6",
    Count: 1300
  },
  {
    name: "7",
    Count: 1350
  },
  {
    name: "8",
    Count: 1350
  },
  {
    name: "9",
    Count: 1450
  },
  {
    name: "10",
    Count: 1560
  },
  {
    name: "11",
    Count: 1673
  }
];

export default class ActivityLineChart extends PureComponent {
  render() {
    const { chart, dataKey } = this.props;

    const retData = chart ? chart : data;

    return (
      <ResponsiveContainer width="100%" height="100%">
        <LineChart width={200} height={20} data={retData}>
          <Tooltip />
          <Line dataKey={"Count"} stroke="#6E3CA7" dot={false} />
          <XAxis dataKey={"name"} hide />
        </LineChart>
      </ResponsiveContainer>
    );
  }
}
